import { get, post, remove } from "./api";
import routes from "./end-points";

export const adminCourseApi = {
    initCourses: (dto) => post(routes.adminCourse.initCourses, dto),
    initCourse: (id) => get(routes.adminCourse.initCourse(id)),
    saveChanges: (dto) => post(routes.adminCourse.saveChanges, dto),
    delete: (id) => remove(routes.adminCourse.delete(id)),
};
